export default __webpack_public_path__ + "static/media/bg30.2b16317f.jpg";